import React, { Fragment, useState } from "react";
import SideBar from "../Sidebar/SideBar";

import "./Upload.css";

import DragNDrop from "./DragNDrop";

// ⭐ Material-UI Core Import hinzugefuegt, damit TextField existiert
import { TextField, Box } from "@material-ui/core";

function UploadPage() {
  return (
    <Fragment>
      <SideBar />
      <div className="home_content">
        <InteractiveForm />
      </div>
    </Fragment>
  );
}

const InteractiveForm = () => {
  const [firstButtonText, setfirstButtonText] = useState("Next Step");
  const [secondButtonText, setSecondButtonText] = useState("Next Step");
  const [containerClasses, setcontainerClasses] = useState(
    "container slider-one-active"
  );

  const [requestData, setrequestData] = useState({
    uploadFile: undefined,
    composer: "",
    sheetName: "",
    releaseDate: "1999-12-31",
    sheetImageUrl: "",
    composerImageUrl: "",
  });

  const firstButtonOnClick = (e) => {
    e.preventDefault();
    setfirstButtonText("Saving...");
    setcontainerClasses("container center slider-two-active");
  };

  const secondButtonOnClick = (e) => {
    e.preventDefault();
    setSecondButtonText("Saving...");
    setcontainerClasses("container full slider-three-active");
  };

  const handleChange = (event) => {
    setrequestData({
      ...requestData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Fragment>
      <div class={containerClasses}>
        <div class="steps">
          <div class="step step-one">
            <span>Information</span>
          </div>
          <div class="step step-two">
            <span>Upload</span>
          </div>
          <div class="step step-three">
            <span>Conclusion</span>
          </div>
        </div>
        <div class="line">
          <div class="dot-move"></div>
          <div class="dot zero"></div>
          <div class="dot center"></div>
          <div class="dot full"></div>
        </div>
        <div class="slider-ctr">
          <div class="slider">
            <form className="slider-form slider-one">
              <h2>Type in the data of the sheet</h2>
              
              {/* 1. Die originalen Pflichtfelder im gewohnten CSS-Label */}
              <label className="input">
                <TextField
                  id="standard-basic-sheet"
                  label="Sheet Name"
                  name="sheetName"
                  value={requestData.sheetName}
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  id="standard-basic-comp"
                  label="Composer"
                  name="composer"
                  value={requestData.composer}
                  onChange={handleChange}
                  fullWidth
                />
              </label>

              {/* ⭐ 2. Die Material-UI Box zwingt die Felder ins sichtbare Layout */}
              <Box display="flex" flexDirection="column" gridGap="15px" style={{ gap: "15px", marginTop: "20px", width: "100%" }}>
                <TextField
                  id="standard-basic-sheet-url"
                  label="Sheet Vorschau-Bild URL (Optional)"
                  name="sheetImageUrl"
                  value={requestData.sheetImageUrl}
                  onChange={handleChange}
                  fullWidth
                />
                <TextField
                  id="standard-basic-composer-url"
                  label="Composer Portrait-Bild URL (Optional)"
                  name="composerImageUrl"
                  value={requestData.composerImageUrl}
                  onChange={handleChange}
                  fullWidth
                />
              </Box>

              <button
                disabled={
                  requestData.sheetName === "" || requestData.composer === ""
                }
                className="first next interactive-form-button"
                onClick={firstButtonOnClick}
                style={{ marginTop: "25px" }}
              >
                {firstButtonText}
              </button>
            </form>


            <form class="slider-form slider-two">
              <h2>Upload the PDF</h2>
              <DragNDrop
                requestData={requestData}
                secondButtonOnClick={secondButtonOnClick}
                secondButtonText={secondButtonText}
                giveModalData={(file) => setrequestData({ ...requestData, uploadFile: file })}
              />
            </form>
            <div class="slider-form slider-three three">
              <h2>
                The Sheet, <span class="yourname">{requestData.sheetName}</span>
              </h2>
              <h3 className="minus-marg">has been succesfully uploaded</h3>
              <a class="reset" href="/">
                Home
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default UploadPage;
